import React from 'react'
import { Segment, Transition, Popup, Button, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import Badge from './Badge'
import questionIcon from '../assets/iconaDOMANDA.svg'
import balanceIcon from '../assets/iconaBOTTINO.svg'
import betIcon from '../assets/iconaCOIN.svg'
import chartIcon from '../assets/iconaCLASSIFICA.svg'
import UserBadge from './UserBadge'

const balanceStyle = {
    button: {
        border: '1px solid #ffe445',
        color: '#ffe445'
    }
  }

const PreloadImages = ({ images }) => <div style={{ position: 'fixed', left: '-9999em', top: '-9999em' }}>
    {images.map((src, i) => <img key={i} src={src} alt='preload' />)}
</div>

const CurrentBalance = ({ balance }) => <Badge icon={balanceIcon} text={balance} popup = {'Punti Attuali'} />
const CurrentBet = ({ bet }) => <Badge icon={betIcon} text={bet}  popup = {'Scommessa Attuale'}/>
const QuestionsCounter = ({ match }) => <Badge icon={questionIcon} text={`${match.currentQuestionIndex}/${match.totalQuestions}`}  popup = {'Numero domanda'}/>                
const ChartBadge = ({ position,over }) => <Badge icon={chartIcon} text={((position+1)?(position+1):'?')+"/"+(over<1000?over:(Math.floor(over/1000)+"k+"))}  popup = {'Posizione in classifica'}/>                


const Balance = ({ balance, user, user_answer, match, position,numPlayers, handleLogOut, deleteUser}) => (
    <Segment style={{ textAlign: 'left', marginTop: 0, marginBottom: 0 }}>
        <PreloadImages images={[questionIcon, balanceIcon, betIcon, chartIcon ]} />
       
        <Transition.Group animation='fade left' style={{ display: 'flex', whiteSpace: 'nowrap', overflow: 'auto' }}>
            <CurrentBalance balance={user_answer && user_answer.is_notified === 0?(
                                                user_answer.bet?user_answer.old_balance-user_answer.bet:user_answer.old_balance): balance} />
            {user_answer && user_answer.bet && user_answer.is_notified !== 1 && <CurrentBet bet={user_answer.bet} />}
            {match && match.currentQuestionIndex && <QuestionsCounter match={match} />}
            {match && (!match.ending_time) && position!==undefined && <ChartBadge position={position} over = {numPlayers}/>}
            <div style={{ flex: 1 }}></div>
            {user && <UserBadge deleteUser = {deleteUser} gameIsOn={match && (match.ending_time?false:true)}/>}
            <Popup trigger={
                <Button animated='fade' style = {balanceStyle.button}>
                        <Button.Content hidden>Esci</Button.Content>
                        <Button.Content visible>
                        <Icon name='sign out' />
                    </Button.Content>
                </Button>
            } content={<Button color='red' content='Confermo di voler uscire' onClick = {handleLogOut}  />}
            on='click'
            position='top right'
          />
        </Transition.Group>
    </Segment>
)


const mapStateToProps = (state) => ({
    balance: state.balance,
    user: state.user,
    user_answer: state.match ? state.userAnswer[state.match.id + " " + state.currentQuestionId] : null,
    match: state.match,
    socket: state.socket,
    position: state.user.position,
    numPlayers: state.numPlayers
})

export default connect(
    mapStateToProps
)(Balance)


// WEBPACK FOOTER //
// ./src/components/Balance.js